import React, { memo } from 'react'
import { useTheme } from 'emotion-theming'

export const MegaPhone = memo(() => {
	const {
		colors: { secondary },
	} = useTheme()
	return (
		<svg width="24px" height="24px" viewBox="0 0 24 24">
			<g
				id="Version-5---CURRENT---Post-Stakeholder-Review-3"
				stroke="none"
				strokeWidth={1}
				fill="none"
				fillRule="evenodd"
			>
				<g
					id="6.2-Mobile-Tablet-HamburgerMenu-Catagories-LoggedOut"
					transform="translate(-64.000000, -239.000000)"
					fill={secondary}
				>
					<g id="ic_advertiseWithUs" transform="translate(64.000000, 239.000000)">
						<path
							d="M16,11.71966 L6,9.21966003 L6,4.78166003 L16,2.28166003 L16,11.71966 Z M2,5.00066003 L4,5.00066003 L4,9.00066003 L2,9.00066003 L2,5.00066003 Z M17.615,0.212660025 C17.372,0.0216600253 17.055,-0.0453399747 16.757,0.0306600253 L4.877,3.00066003 L2,3.00066003 C0.897,3.00066003 0,3.89666003 0,5.00066003 L0,9.00066003 C0,10.10266 0.897,11.00066 2,11.00066 L4,11.00066 L4,13.00066 C4,13.21766 4.07,13.42766 4.2,13.60066 L7.2,17.60066 L8.8,16.40066 L6,12.66666 L6,11.28166 L16.757,13.97066 C16.837,13.99066 16.919,14.00066 17,14.00066 C17.221,14.00066 17.438,13.92766 17.615,13.78866 C17.858,13.59866 18,13.30866 18,13.00066 L18,1.00066003 C18,0.692660025 17.858,0.401660025 17.615,0.212660025 L17.615,0.212660025 Z"
							id="Fill-1989"
						/>
					</g>
				</g>
			</g>
		</svg>
	)
})
